import * as React from 'react';
import { Button, Title } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { createStyles } from "@mantine/core";
import { useNavigate } from "react-router-dom";

interface PageHeaderProps {
    title: string;
    backRoute?: string;
    children?: React.ReactNode;
}

const useStyles = createStyles((theme) => {
    const primaryColor = theme.primaryColor;
    const color = theme.colors[primaryColor][6];
    return {
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: `1px solid ${theme.fn.lighten(
                theme.fn.variant({ variant: 'filled', color: theme.primaryColor }).background!,
                0.1
            )}`,
            paddingBottom: '1.3rem',
            marginBottom: theme.spacing.lg,
        },
        title: {
            display: 'flex'
        },
        wrapper: {
            display: 'flex',
            justifyContent: 'center'
        }
    }
})

const PageHeader = ({
    title,
    backRoute,
    children
}: PageHeaderProps) => {
    const { classes } = useStyles();
    const navigate = useNavigate();

    return (
        <div className={classes.header}>
            <div className={classes.title}>
                {
                    backRoute && (
                        <Button
                            leftIcon={<IconArrowLeft />}
                            variant="white"
                            onClick={() => navigate(backRoute)}
                            size='sm'
                        />
                    )
                }
                <Title order={2} variant='gradient'>{title}</Title>
            </div>
            <div className={classes.wrapper}>
                {children}
            </div>
        </div>
    );
};

export default PageHeader;